import { queryRequest } from './client';
import { getSearch, getSearchClipCollection } from './queries';
import SearchResult from '../models/SearchResult';
import SearchClipCollection from '../models/SearchClipCollection';
import { isEmpty } from 'util/index';
import SHOW_MORE from '../../globalConst/searchResults-const';

/**
 * Fetch search results from the universal api
 * @param {string} query
 * @returns {Array} collections
 */
export const fetchSearch = async (query) => {
  const { data } =
    (await queryRequest({
      query: getSearch,
      variables: { query },
    })) || {};
  return new SearchResult(data);
};

export const fetchSearchClipCollection = async ({ slug, query, data: currentData }) => {
  if (!query) {
    return;
  }

  const limit = SHOW_MORE.PODCASTS.DEFAULT_EPISODE_LIMIT;

  const { data } = await queryRequest({
    query: getSearchClipCollection,
    variables: { slug, query, limit, nextToken: currentData?.nextToken },
  });

  let response = new SearchClipCollection({ ...data.clips, title: 'Podcast afleveringen' });

  if (!isEmpty(currentData)) {
    response = {
      ...response,
      items: [...currentData.items, ...response.items],
    };
  }

  const nextLoadCount = response.totalCount - response.items.length;

  return {
    ...response,
    nextLoadCount: nextLoadCount < limit ? nextLoadCount : limit,
    hasMoreItems: nextLoadCount > 0,
  };
};
